import { render, staticRenderFns } from "./PackageBestMix.vue?vue&type=template&id=1c9e0ec2&scoped=true"
import script from "./PackageBestMix.vue?vue&type=script&lang=js"
export * from "./PackageBestMix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9e0ec2",
  null
  
)

export default component.exports